import React from 'react'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { faClock } from '@fortawesome/free-regular-svg-icons'
import moment from 'moment'

import { TARGET_CLASS } from '../../utils/visible'

import './index.scss'

export const ThumbnailItem = ({ node }) => (
  <Link className={`thumbnail ${TARGET_CLASS}`} to={node.fields.slug}>
    <div key={node.fields.slug}>
      <h3>{node.frontmatter.title || node.fields.slug}</h3>
      <div className="thumbnail-subinfo">
        <time dateTime={node.frontmatter.date}>
          <FontAwesomeIcon icon={faClock} style={{ marginRight: "1px" }} />
          {moment(node.frontmatter.date).fromNow()}
        </time>
        &nbsp;&nbsp;&nbsp;
        <span className="subinfo-category">
          <FontAwesomeIcon icon={faLink} style={{ marginRight: "1px" }} />
          {node.frontmatter.category}
        </span>
      </div>
      <div className="line" />
      <p dangerouslySetInnerHTML={{ __html: node.excerpt }} />
    </div>
  </Link>
)
